import { type FC } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'

import TaskV2View from './TaskV2View'
import WorkflowTasksListView from './WorkflowTasksListView'

const WorkflowTasksApp: FC = () => {
  return (
    <BrowserRouter>
      <div className='min-h-screen min-w-screen bg-gray-50'>
        <Routes>
          {/* V2 Workflow Tasks SPA routes */}
          <Route path='/admin/tasks/v2' element={<WorkflowTasksListView />} />
          <Route path='/admin/tasks/v2/:taskType' element={<TaskV2View />} />
          {/* TODO: Currently linking out to the brokers Workflows UI for task specific info. Decide if we want to handle this within the SPA */}
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default WorkflowTasksApp
